import React, { useState, useEffect } from 'react';
import es from "date-fns/locale/es";
import { Typography, TextField, Checkbox, FormControl, Select, MenuItem, RadioGroup, FormControlLabel, Radio, InputLabel } from '@mui/material';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import TimePicker from '@mui/lab/TimePicker'; 
import { ObtenerListadoRegistrosGenericos } from '../../../Actions/Utilidades/CodigosSistemaAction';
import { ObtenerListadoCamposDinamicosRadios } from '../../../Actions/Utilidades/CamposDinamicosAction';
import { useStateValue } from '../../../Contexto/store';
import InputMask from 'react-input-mask';
import AccionesUsuario from '../../../Configuracion/Llaves/AccionesUsuario';
import { enlistaArrayCodigosMensajesIdiomas } from '../../../Actions/Generales/IdiomasAction';
import { MostrarMensaje } from '../../../Utilidades/ManejoMensajes';
import { getFormatDateLocalStorage } from '../../../Utilidades/LeerInfoLocalStorage';

const idioma = localStorage.getItem("etiqueta_idioma") || "ES";

const InputsField = ({ CampoDinamico, IdRelacionado, SectionId, SubModuloId, Elemento = '' }) => {

    const [{ sesionUsuario }] = useStateValue();

    //variable de estado local para las propiedades del componente 
    const [campoX, setCampoX] = useState(CampoDinamico);
    const [listado, setListado] = useState([]);
    const [check, setCheck] = useState(false);

    useEffect(() => {
        ObtenerLista();
    }, [IdRelacionado]);

    const ObtenerLista = async () => {
        if (campoX.typeField === 'LIST') {
            campoX.dataField = campoX.dataField.toLowerCase();
            setCampoX(campoX);
            const response = await ObtenerListadoRegistrosGenericos(campoX.listRecords, '', sesionUsuario.usuario.companyId, sesionUsuario.usuario.userId, '', true)
            if (response.status === 200) {
                setListado(response.data);
            } else {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
                setListado([]);
            }
        }
        else if (campoX.typeField === 'RADIO') {
            campoX.dataField = campoX.dataField.toUpperCase();
            setCampoX(campoX);
            const Params = {
                SectionId: SectionId,
                FileName: campoX.fieldName,
                IdRel: IdRelacionado,
                PeticionUsuario: {
                    CompanyId: sesionUsuario.usuario.companyId,
                    UserId: sesionUsuario.usuario.userId,
                    OptionId: SubModuloId,
                    Action: AccionesUsuario.Consultar
                }
            };
            const response = await ObtenerListadoCamposDinamicosRadios(Params);
            if (response.status === 200) //si la respuesta fue existosa 
            {
                //console.log("radios", response.data);
                setListado(response.data[0]?.fieldList);
            } else {
                if (response.data.errors) {
                    const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                    MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                } else {
                    MostrarMensaje(dispatch, 'error', [response.statusText]);
                }
                setListado([]);
            }
        }
        else if (campoX.typeField === 'CHECK') {
            setCheck(campoX.dataField === "1");
        }
    }    

    return (
        <React.Fragment>
            {(campoX.typeField === 'CHECK') ?
                (
                    <div style={{ padding: '0px', margin: '0px', width: '100%', display: 'inline-block' }}>
                        {
                            creaComponenteInput(campoX, setCampoX, CampoDinamico, listado, check, setCheck)
                        }
                        <Typography variant='subtitle2' name={campoX.fieldId}
                            style={{ fontSize: 16, marginBottom: 0, fontWeight: 'normal', display: 'inline-block' }}>{campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}</Typography>
                    </div>
                 )
                :
                creaComponenteInput(campoX, setCampoX, CampoDinamico, listado, check, setCheck)
                }
            
         </React.Fragment>
    )
}

const creaComponenteInput = (campoX, setCampoX, CampoDinamico, listFiels, check, setCheck) => {

    const [formatoFecha, setFormatoFecha] = useState('dd/MM/yyyy');

    useEffect(() => {
        setFormatoFecha(getFormatDateLocalStorage());
    }, []);

    const ingresarValoresMemoria = e => {
        const { value } = e.target;  // se desestructura del targen el nombre y el valor que trae
        // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el 
        // valor que se le envia lo demas se queda igual 
        setCampoX((anterior) => ({
            ...anterior,
            ["dataField"]: value
        }));
        CampoDinamico.dataField = value;
    };

    const ingresarValoresMemoriaCheck = e => {
        const { checked } = e.target;  // se desestructura del targen el nombre y el valor que trae
        // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el 
        // valor que se le envia lo demas se queda igual 
        setCampoX((anterior) => ({
            ...anterior,
            ["dataField"]: checked
        }));
        setCheck(checked);
        CampoDinamico.dataField = checked.toString();
    };

    const ingresarValoresMemoriaFecha = e => {
        let newValueCampo = (e === null) ? "" : e;
        setCampoX((anterior) => ({
            ...anterior,
            ["dataField"]: newValueCampo
        }));
        CampoDinamico.dataField = newValueCampo;
    };

    const ingresarValoresMemoriaNumericos = e => {
        const { value } = e.target;  // se desestructura del targen el nombre y el valor que trae

        let valorfinal = value;

        // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el 
        // valor que se le envia lo demas se queda igual 
        setCampoX((anterior) => ({
            ...anterior,
            ["dataField"]: valorfinal
        }));
        CampoDinamico.dataField = valorfinal;
    };

    if (campoX.typeField === 'SHT_TEXT') {
        return campoX.pattern !== '' ? <InputMask
            id={campoX.fieldId}
            name={campoX.fieldName}
            mask={campoX.pattern}
            value={campoX.dataField}
            onChange={ingresarValoresMemoria}
            disabled={false}
            maskChar=" "
        >
            {() => <TextField
                /*required={campoX.isRequired}*/
                variant="outlined"
                fullWidth
                label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
                inputProps={{ maxLength: campoX.maxlength }} />}
        </InputMask> : <TextField id={campoX.fieldId}
            name={campoX.fieldName}
            value={campoX.dataField}
            onChange={ingresarValoresMemoria}
            /*required={campoX.isRequired}*/
            label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
            variant="outlined"
            fullWidth
            inputProps={{ maxLength: campoX.maxlength }} />
    }
    else if (campoX.typeField === 'EMAIL') {
        return <TextField name={campoX.fieldName}
            /*required={campoX.isRequired}*/
            id={campoX.fieldId}
            value={campoX.dataField}
            onChange={ingresarValoresMemoria}
            variant="outlined"
            fullWidth
            label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
            inputProps={{ maxLength: campoX.maxlength }} />
    }
    else if (campoX.typeField === 'LRG_TEXT') {
        return <TextField
            /*required={campoX.isRequired}*/
            id={campoX.fieldId}
            name={campoX.fieldName}
            value={campoX.dataField}
            variant="outlined"
            multiline
            rows={2}
            fullWidth
            label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
            onChange={ingresarValoresMemoria}
            inputProps={{
                maxLength: campoX.maxlength
            }}>
        </TextField>
    }
    else if (campoX.typeField === 'WHL_NUM') {
        return <TextField name={campoX.fieldName}
        /*required={campoX.isRequired}*/
            id={campoX.fieldId}
            type="number"
            value={campoX.dataField}
            onChange={ingresarValoresMemoriaNumericos}
            variant="outlined"
            fullWidth
            label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
            InputProps={{ inputProps: { min: campoX.minimum, max: campoX.maximum } }}
            InputLabelProps={{
                shrink: true
            }}
        />
    }
    else if (campoX.typeField === 'DEC_NUM') {
        return <TextField name={campoX.fieldName}
        /*required={campoX.isRequired}*/
            id={campoX.fieldId}
            type="number"
            value={campoX.dataField}
            onChange={ingresarValoresMemoriaNumericos}
            variant="outlined"
            fullWidth
            label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
            InputProps={{ inputProps: { min: campoX.minimum, max: campoX.maximum, step: campoX.decimal } }}
            InputLabelProps={{
                shrink: true                
            }}
        />
    }
    else if (campoX.typeField === 'DATE') {
        return <LocalizationProvider dateAdapter={AdapterDateFns} locale={idioma === "ES" ? es : ''}>
            <DesktopDatePicker
                format="YYYY-MM-DD"
                /*required={campoX.isRequired}*/
                inputFormat={formatoFecha}
                id={campoX.fieldId}
                name={campoX.fieldName}
                value={(campoX.dataField === "" ? null : campoX.dataField)}
                variant="outlined"
                label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
                onChange={(newValue) => {                    
                    ingresarValoresMemoriaFecha(newValue);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
            />
            {/*required={campoX.isRequired}*/}
            {/*minDate={new Date('1938-01-01')}*/}
            {/*maxDate={new Date()}*/}           
        </LocalizationProvider>
    }
    else if (campoX.typeField === 'HOUR') {
        return <LocalizationProvider dateAdapter={AdapterDateFns}>            
            <TimePicker
                id={campoX.fieldId}
                /*required={campoX.isRequired}*/
                name={campoX.fieldName}
                value={(campoX.dataField === "" ? null : campoX.dataField)}
                label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
                onChange={(newValue) => {
                    ingresarValoresMemoriaFecha(newValue);
                }}
                renderInput={(params) => <TextField fullWidth {...params} />}
            />
        </LocalizationProvider>
    }
    else if (campoX.typeField === 'RADIO') {
        return <FormControl fullWidth variant="outlined">
            <RadioGroup id={campoX.fieldId} name={campoX.fieldName} value={campoX.dataField} onChange={ingresarValoresMemoria} row>
                {
                    listFiels.map((record) => (<FormControlLabel key={"ident-" + record.fieldId} value={record.value.toUpperCase()} control={<Radio />} label={record.fieldDescrp} />))
                }
            </RadioGroup>
        </FormControl>
    }
    else if (campoX.typeField === 'CHECK') {
        return <Checkbox
                id={campoX.fieldId}
                checked={check}
                onChange={ingresarValoresMemoriaCheck}
                color="primary"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
    }
    else if (campoX.typeField === 'LIST') {
        return <FormControl fullWidth variant="outlined">
            <InputLabel id={campoX.fieldId + "-label"}>{campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}</InputLabel>
            <Select id={campoX.fieldId}
            /*required={campoX.isRequired}*/
                name={campoX.fieldName}
                value={campoX.dataField}
                onChange={ingresarValoresMemoria}
                label={campoX.fieldDescrp + (campoX.isRequired ? ' *' : '')}
                labelId={campoX.fieldId + "-label"}>
                {
                    listFiels.map((record) => (<MenuItem key={"ident-" + record.id} value={record.id}>{record.description}</MenuItem>))
                }
            </Select>
        </FormControl>
    }
}

export default InputsField;